import { render, staticRenderFns } from "./BeGoodAt.vue?vue&type=template&id=3ecbf56f&scoped=true"
import script from "./BeGoodAt.vue?vue&type=script&lang=js"
export * from "./BeGoodAt.vue?vue&type=script&lang=js"
import style0 from "./BeGoodAt.vue?vue&type=style&index=0&id=3ecbf56f&prod&lang=scss&scoped=true"
import style1 from "./BeGoodAt.vue?vue&type=style&index=1&id=3ecbf56f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecbf56f",
  null
  
)

export default component.exports